/**
 * Created by markusr on 2.6.2015.
 */

define('helperLayout-createNode',[],function() {
    'use strict';

    var createNode = function(options) {
        options = options || {};

        var ID = options.ID || '',
            node = null,
            previous = null,
            content = (options.content) ? options.content : '',
            type = options.type || 'html';

        if (ID) {
            previous = document.getElementById(ID);
        }

        if (previous) {
            previous.parentNode.removeChild(previous);
        }

        if (!content) {
            return;
        }

        switch(type) {
            case 'css':
                node = document.createElement('style');
                node.setAttribute('type', 'text/css');
                break;
            case 'js':
                node = document.createElement('script');
                break;
            default:
                node = document.createElement('div');
        }

        if (ID) {
            node.setAttribute('id', ID);
        }

        node.innerHTML = content;

        return node;
    };

    return createNode;

});

